import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import HomePage from '../pages/HomePage';

const HomePageRedirect = () => {
  const { user } = useAuth();
  
  console.log('HomePageRedirect - Current user:', user);
  
  // 管理者はトップページにアクセスした場合でもホームを表示（リダイレクトしない）
  // 管理者としての遷移は明示的に /admin-login または /admin/* から行う
  
  // 事業者の場合は事業者ダッシュボードにリダイレクト（従来通り）
  if (user && user.user_type === 'employer') {
    return <Navigate to="/employer-dashboard" replace />;
  }
  
  // 求職者またはログインしていない場合は通常のHomePage
  return <HomePage />;
};

export default HomePageRedirect;